

<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('aboutUs.Header') }}</h2>
                <h3>{{ $t('aboutUs.HistoryHeader') }}</h3>
                {{ $t('aboutUs.HistoryText1') }}
                <br />
                {{ $t('aboutUs.HistoryText2') }}
                <br />
                {{ $t('aboutUs.Successes') }}
                <br />
                <h3>{{ $t('aboutUs.TodayHeader') }}</h3>
                {{ $t('aboutUs.TodayText1') }}
            </div>
        </div>
        <div id="image_holder" class="imageHolder">
            <div id="gridAboutus">
                <kendo-datasource ref="datasourceAboutus"
                                  :transport-read-url="url"
                                  :transport-read-data-type="'jsonp'">
                </kendo-datasource>
                <kendo-grid :data-source-ref="'datasourceAboutus'"
                            :mobile="true">
                    <kendo-grid-column :field="'Mitgliederanzahl'"
                                       :title="$t('aboutUs.GridColumnHeaderNumberOfMembers')"></kendo-grid-column>
                    <kendo-grid-column :field="'MinAlter'"
                                       :title="$t('aboutUs.GridColumnHeaderYoungestMember')"></kendo-grid-column>
                    <kendo-grid-column :field="'MaxAlter'"
                                       :title="$t('aboutUs.GridColumnHeaderOldestMember')"></kendo-grid-column>
                    <kendo-grid-column :field="'AnzahlDan'"
                                       :title="$t('aboutUs.GridColumnHeaderNumberOfDanHolders')"></kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
        <div class="transbox">
            <div class="transboxContent">
                <br />
                {{ $t('aboutUs.TodayText2') }}
                <br />
                {{ $t('aboutUs.TodayText3') }}
                <br />
                {{ $t('aboutUs.TodayText4') }}
                <br />
                <h3>{{ $t('aboutUs.TogetherHeader') }}</h3>
                {{ $t('aboutUs.TogetherText') }}
                <br />
                {{ $t('aboutUs.LinkHeader') }}
                <ul>
                    <li>Stadtsportbund Bochum (<a href="http://www.ssb-bochum.de" target="_blank">SSB</a>)</li>
                    <li>Landessportbund (<a href="http://www.wir-im-sport.de" target="_blank">LSB</a>)</li>
                    <li>Deutschen Sportbund (<a href="http://www.deutschersportbund.de" target="_blank">DSB</a>)</li>
                    <li>Nordrhein-Westf&auml;lischen Taekwondo Union  (<a href="http://www.nwtu.de" target="_blank">NWTU</a>)</li>
                    <li>Deutschen Taekwondo Union (<a href="http://www.dtu.de" target="_blank">DTU</a>)</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/classes/eventBus.js';
    import '@progress/kendo-ui';
    import '@progress/kendo-theme-default/dist/all.css';
    import kendo from '@progress/kendo-ui';
    import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper';
    import { KendoDataSource } from '@progress/kendo-datasource-vue-wrapper';
    import config from "@/appdata/config.json";

    export default {
        components: {
            'kendo-grid': Grid,
            'kendo-grid-column': GridColumn,
            'kendo-datasource': KendoDataSource
        },
        props: {
            linkItem: String,
            myText: String,
            url: String
        },
        data: function () {
            return {
                theImage: '',
                schemaModelFields: {
                    Mitgliederanzahl: { validation: { required: true } },
                    MinAlter: { validation: { required: true } },
                    MaxAlter: { validation: { required: true } },
                    AnzahlDan: { validation: { required: true } }
                }
            }
        },
        computed: {
        },
        mounted() {
            window.$ = kendo.jQuery;
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        created() {
            this.url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Ueberuns"
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>